<!-- My Tickets -->
<section class="myTickets">
  <div class="title-wrapper">
    <h4 class="title-text text-primary">{{ "My Weapon Access Requests" | translate }}</h4>
    <div class="title-actionWrapper">

      <button
        class="btn btn-light title-action"
        routerLink="/weapons/new-requests"
      >
        <i class="fas fa-plus mr-3 text-primary align-middle"></i>
        <span>{{ "Add New Request" | translate }}</span>
      </button>
    </div>

  </div>
  <div class="row" *ngIf="requests && requests.length > 0; else noData">
    <div class="col-12">
      <div class="table-responsive">
        <table class="table table-default invitations-table">
          <thead class="table-header text-center">
          <tr>
            <th scope="col">
              {{ "Request Number" | translate }}
            </th>
            <th scope="col">
              {{ "Weapon Number" | translate }}
            </th>
            <th scope="col">
              {{ "Weapon Brand" | translate }}
            </th>
            <th scope="col">
              {{ "Key Number" | translate }}
            </th>
            <th scope="col">
              {{ "Received At" | translate }}
            </th>
          </tr>
          </thead>
          <tbody class="table-body">
          <tr class="text-center" *ngFor="let request of requests; let i = index">

            <td scope="col">{{ request?.number }}</td>
            <td scope="col">{{ request?.weapons.weaponNumber }}</td>
            <td scope="col">{{ request?.weapons.brand }}</td>
            <td scope="col">
              <span *ngIf="request?.keynumber">{{ request?.keynumber }}</span>
              <span *ngIf="!request?.keynumber">-</span>
            </td>
            <td scope="col" >
              {{ request?.receivedAt | date : "dd/MM/yyyy" }} {{ request?.receivedAt | date : " h:mma" }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <app-pagination
    *ngIf="meta"
    [meta]="meta"
    (goPage)="goToPage($event)"
    (goNext)="onNext()"
    (goPrev)="onPrev()"
  >
  </app-pagination>
</section>

<ng-template #noData>
  <app-nodata
    title="{{ 'No Request Added' | translate }}"
    desc="{{ 'No Request Raised By Your Account' | translate }}"
    [img]="'assets/images/tickets/no-ticket.png'"
    link=""
  ></app-nodata>
</ng-template>

<ng-template #loading>
  <div class="text-center">
    <i class="fas fa-spin fa-spinner fa-3x"></i>
  </div>
</ng-template>
